import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// Import Images
import bg1 from '../../images/main-banner/bg1.jpg';
import doctorImg from '../../images/main-banner/doctor.png';
import ptImg1 from '../../images/shap/trangle-orange.png';
import ptImg2 from '../../images/shap/square-blue.png';
import ptImg3 from '../../images/shap/chicle-blue-2.png';
import ptImg4 from '../../images/shap/plus-orange.png';
import ptImg5 from '../../images/shap/wave-orange.png';

function MyVerticallyCenteredModal(props) {
	const customStyles = {
 
		overlay: {zIndex: 99999999999999999999999999999999999999999}
	  };
	  
	  
	return (
	  <Modal
		{...props}
		size="lg"
		aria-labelledby="contained-modal-title-vcenter"
		centered
		style={customStyles}
	  >
		<Modal.Header closeButton>
		  <Modal.Title id="contained-modal-title-vcenter">
			Sobre el Dr. Eduardo Alavarez del Castillo.
		  </Modal.Title>
		</Modal.Header>
		<Modal.Body>
		  
		  <p>
		UNIVERSIDAD NACIONAL AUTONOMA DE MEXICO. <br></br>
		EGRESADO HOSPITAL ESPAÑOL DE MEXICO.<br></br>
		ESPECIALIDAD CIRUGIA GENERAL.<br></br>
		VIDEO CIRUGIA LAPAROSCOPICA.<br></br>
		GASTROENTEROLOGIA.<br></br>
		CIRUGIA DE LA OBESIDAD POR LAPAROSCOPIA.<br></br>
		TRATAMIENTO MULTIDISCIPLINARIO DE LA OBESIDAD.<br></br>
		EX JEFE DE ENSEÑANZA E INVESTIGACION HOSPITAL CENTRAL MEDICO QUIRURGICA.<br></br>
		PRESIDENTE FUNDADOR DEL COLEGIO DE CIRUJANOS DE AGUASCALIENTES.<br></br>
		EX SUBDIRECTOR DE AUDITORIA MEDICA DEL INSTITUTO DE SALUD DEL ESTADO DE AGS.<br></br>
		COORDINADO DE LOS SERVICIOS MEDICOS DEL MUNICIPIO DE AGUASCALIENTES<br></br>
		PROFESOR DE CIRUGIA CENTRAL MEDICO QUIRURGICA DE AGUASCALIENTES.<br></br>
		FUNDADOR DEL SISTEMA DE  ATENCION PREHOSPITALARIA ISEA.<br></br>
		FUNDADOR DE LA ESCUELA ESTATAL DE PARAMEDICOS DEL ISEA AGUASCALIENTES.<br></br>
		INSTRUCTOR DE ATLS ( ADVANCED TRAUMA LIFE SUPORT ).<br></br>
		  </p>
		</Modal.Body>
		<Modal.Footer>
		  <Button onClick={props.onHide}>Cerrar</Button>
		</Modal.Footer>
	  </Modal>
	);
  }
  
  function App() {
	const [modalShow, setModalShow] = React.useState(false);
  
	return (
	  <>
	<div className="banner-img" onClick={() => setModalShow(true)}>
		<img src={doctorImg} alt=""/>
		<p className="title-ext doc-text"><span className="bolded">Dr </span>Eduardo Álvarez del Castillo Sánchez | Especialista en Cirugía General | Gastroenterólogo | Laparoscopista</p>							
									
	</div>
	
		 
		<MyVerticallyCenteredModal
		  show={modalShow}
		  onHide={() => setModalShow(false)}
		/>
	  </>
	);
  }
  
class aboutSection extends Component{
	
	render(){
		return(
			<>
				
				<div className="main-banner" style={{backgroundImage: "url("+bg1+")"}}>
					<div className="container inner-content">
						<div className="row align-items-center">
							<div className="col-lg-7 col-md-6 col-sm-7">
								<h6 className="title-ext text-primary">La mejor opción para recuperar su salud</h6>
								<h1>Proteja su salud y cuide su bienestar</h1>
								<Link to="/acerca-de" className="btn btn-secondary btn-lg shadow">Saber mas</Link>
							</div>
							<div className="col-lg-5 col-md-6 col-sm-5">
							<App />
								
								
							</div>
						</div>
					</div>
					<img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate3" src={ptImg3} alt=""/>
					<img className="pt-img4 animate4" src={ptImg4} alt=""/>
					<img className="pt-img5 animate-wave" src={ptImg5} alt=""/>
				</div>
				
			</>
		);
	}
}

export default aboutSection;